import './button.style.scss';

import React, { useState, useEffect, useRef } from 'react';
import {
  CloudDownloadOutlined,
  UpOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const ButtonComponent = () => {
  const buttonRef = useRef<HTMLElement | null>(null);
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleClose = (event) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        setVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClose);
    return () => {
      document.removeEventListener('mousedown', handleClose);
    };
  });

  return (
    <div style={{ textAlign: 'center', position: 'relative' }}>
      <Button
        style={{ backgroundColor: '#3ADCC9', color: '#fff', border: 0 }}
        onClick={() => setVisible(!visible)}
        icon={<CloudDownloadOutlined />}
      >
        {t('APP.VIGNETTE.DELIVERABLES.BUTTON.TEXT', {
          defaultValue: 'Télécharger',
        })}
        {!visible ? (
          <UpOutlined style={{ fontSize: 11 }} />
        ) : (
          <DownOutlined style={{ fontSize: 11 }} />
        )}
      </Button>
      {visible && (
        <div className="button__wrapper" ref={buttonRef}>
          <Button className="button__style">
            {t('APP.VIGNETTE.DELIVERABLES.MENUITEM.PDFSYNTHESE', {
              defaultValue: 'Télécharger le PDF de la Synthèse',
            })}
          </Button>
          <Button className="button__style">
            {t('APP.VIGNETTE.DELIVERABLES.MENUITEM.PDFRSEE', {
              defaultValue: 'Télécharger le PDF du RSEE',
            })}
          </Button>
          <Button className="button__style">
            {t('APP.VIGNETTE.DELIVERABLES.MENUITEM.XMLRSEE', {
              defaultValue: 'Télécharger le XML du RSEE',
            })}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ButtonComponent;
